import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';
import isDate from 'lodash/isDate';

import './styles.css';

const RepVisitsWeekOf = ({ dateFrom, dateTo }) => {
  if (!isDate(dateFrom) && !isDate(dateTo)) {
    return null;
  }
  if (dateFrom.getFullYear() !== dateTo.getFullYear()) {
    return (
      <span data-cy="repvisits-week-showing">
        <FormattedDate value={dateFrom} month="short" day="2-digit" year="numeric" />&nbsp;&ndash;&nbsp;
        <FormattedDate value={dateTo} month="short" day="2-digit" year="numeric" />
      </span>
    );
  } else {
    return (
      <span data-cy="repvisits-week-showing">
        <FormattedDate value={dateFrom} month="short" day="2-digit" />&nbsp;&ndash;&nbsp;
        <FormattedDate value={dateTo} month="short" day="2-digit" year="numeric" />
      </span>
    );
  }
};

RepVisitsWeekOf.propTypes = {
  dateFrom: PropTypes.instanceOf(Date).isRequired,
  dateTo: PropTypes.instanceOf(Date).isRequired,
};

export default RepVisitsWeekOf;
